import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { createHoursRange } from '../workingHoursFormCreator';
import { defaultHours } from '../../../lead-generation/shared/domain/WorkingHours';

@Component({
  selector: 'cc-lg-working-hours-range',
  templateUrl: './working-hours-range.component.html',
  styleUrls: ['./working-hours-range.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkingHoursRangeComponent {
  @Input() range: FormGroup;
  @Input() disabledDays: number[];
  @Input() deleteEnabled: boolean;
  @Output() selectionChange = new EventEmitter<number>();
  @Output() deleteClicked = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  get days(): number[] {
    return this.daysForm.value;
  }

  get daysForm(): FormArray {
    return this.range.get('days') as FormArray;
  }

  get hoursFormControls(): AbstractControl[] {
    return this.hoursForm.controls;
  }

  get hoursForm(): FormArray {
    return this.range.get('hours') as FormArray;
  }

  get canRemoveHoursRange() {
    return this.hoursForm.length > 1;
  }

  removeHoursRange(index: number) {
    this.hoursForm.removeAt(index);
  }

  addHoursRange() {
    this.hoursForm.push(createHoursRange(defaultHours, this.fb));
  }

  deleteRange() {
    if (this.deleteEnabled) {
      this.deleteClicked.emit();
    }
  }

  onSelectionChanged(day) {
    const userDeselectedDay = this.days.includes(day);

    if (userDeselectedDay) {
      const index = this.days.indexOf(day);
      this.daysForm.removeAt(index);
    } else {
      this.daysForm.push(new FormControl(day));
    }

    this.selectionChange.emit(day);
  }
}
